import React from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import Title from "../../Components/Utils";
import { Link, useNavigate } from "react-router-dom";

export function BrickPurchase() {
  return (
    <Container className="pb-5">
      <div>
        <Title text="Choose Brick of 10" />
        {/* <Form noValidate validated={validated} onSubmit={handleSubmit}> */}
        <Form>
          <Form.Group as={Row} controlId="formFile" className="mb-3">
            <Form.Label column sm={4} className="contact-upload-label">
              Report Type
            </Form.Label>
            <Col sm={6}>
              <Form.Check
                type="radio"
                id="radio-one"
                name="standard"
                label="STANDARD ($250)"
              />
              <Form.Check
                type="radio"
                id="radio-two"
                name="expanded"
                label="EXPANDED ($400)"
              />
              <Form.Check
                type="radio"
                id="radio-three"
                name="claims"
                label="CLAIMS ($300)"
              />
            </Col>
          </Form.Group>
        </Form>
      </div>
    </Container>
  );
}

export function CreditInformation() {
  const navigate = useNavigate();
  return (
    <Container className="pb-5">
      <div>
        <Title text="Credit Card Information" />
        {/* <Form noValidate validated={validated} onSubmit={handleSubmit}> */}
        <Form>
          <Form.Group as={Row} className="mb-3" controlId="name">
            <Form.Label column sm={4}>
              First Name:
            </Form.Label>
            <Col sm={6}>
              <Form.Control type="text" required />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="name">
            <Form.Label column sm={4}>
              Last Name:
            </Form.Label>
            <Col sm={6}>
              <Form.Control type="text" required />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="name">
            <Form.Label column sm={4}>
              Card Type:
            </Form.Label>
            <Col sm={6}>
              <Form.Select aria-label="Default select example" required>
                {/* <option>Visa</option> */}
                <option value="1">Visa</option>
                <option value="2">Master</option>
                <option value="3">Three</option>
              </Form.Select>
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="card_number">
            <Form.Label column sm={4}>
              Card Number:
            </Form.Label>
            <Col sm={6}>
              <Form.Control type="text" required />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="name">
            <Form.Label column sm={4}>
              Expiration Date:
            </Form.Label>
            <Col sm={3}>
              <Form.Select aria-label="Default select example" required>
                <option value="01">January</option>
                <option value="02">February</option>
                <option value="03">March</option>
                <option value="04">April</option>
                <option value="05">May</option>
                <option value="06">June</option>
                <option value="07">July</option>
                <option value="08">August</option>
                <option value="09">September</option>
                <option value="10">October</option>
                <option value="11">November</option>
                <option value="12">December</option>
              </Form.Select>
            </Col>
            <Col sm={3}>
              <Form.Select aria-label="Default select example" required>
                <option value="2030">2030</option>
                <option value="2029">2029</option>
                <option value="2028">2028</option>
                <option value="2027">2027</option>
                <option value="2026">2026</option>
                <option value="2025">2025</option>
                <option value="2024">2024</option>
                <option value="2023">2023</option>
                <option value="2022">2022</option>
              </Form.Select>
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="security_code">
            <Form.Label column sm={4}>
              Security Code:
            </Form.Label>
            <Col sm={6}>
              <Form.Control type="number" required min={0} />
            </Col>
          </Form.Group>
          <Row>
            <Col sm={4}></Col>
            <Col>
              <Button
                variant="primary"
                type="submit"
                 onClick={() => navigate("/Order")}
              >
                Order
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </Container>
  );
}

export default function PurchaseInfo() {
  return (
    <Container>
      <BrickPurchase />
      <CreditInformation />
    </Container>
  );
}
